import { Controller } from "stimulus"

export default class extends Controller {

  export(event) {
    event.preventDefault()
    const form = this.element.closest("form")
    const url = form.getAttribute('action');
    const formData = new FormData(form)
    const queryString = new URLSearchParams(formData).toString()
    const requestUrl = `${url}?${queryString}`
    fetch(requestUrl, {
      method: "GET",
      headers: {
        Accept: "text/csv,application/json"
      }
    })
      .then(async (response) => {
        function formatDateTimeISO(date) {
          return date.toISOString()
            .replace(/[-:T]/g, '') // 移除 "-"、":" 和 "T"
            .slice(0, 12); // 截取前12字符（YYYYMMDDHHMM）
        }
      
        const contentType = response.headers.get("Content-Type");
        if (response.ok && contentType.includes("text/csv")) {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = formatDateTimeISO(new Date()) + ".csv";
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        } else if (contentType.includes("application/json")) {
          console.log(111)
          const json = await response.json();
          alert(json.error || "导出失败");
        } else {
          alert("导出失败：未知响应类型");
        }
      })
      .catch(() => {
        alert("网络错误或服务器不可用");
      });
  }
}
